// extracted by mini-css-extract-plugin
export default {"root":"StepDescription_root__8tQnu"};